module.exports = __webpack_public_path__ + "static/media/chat-blue.147f32a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chat-blue.svg
// module id = 540
// module chunks = 0